<div class="page-container" animate.enter="route-slide-in-right" animate.leave="route-slide-out-right">
  <div class="page-title-row flex flex-align-center gap-sm mb-md">
    <app-back-button [ariaLabel]="'settings.back' | translate" />
    <h2>{{ 'settings.admin.title' | translate }}</h2>
  </div>

  <app-card>
    <app-card-content>
      <div class="setting-item">
        <div class="setting-header setting-header--full-width flex gap-md flex-grow">
          <div>
            <p class="setting-description">{{ 'settings.admin.description' | translate }}</p>
          </div>
          <app-button variant="outlined" routerLink="/admin/subscriptions" data-testid="go-to-admin-subscriptions-button">
            <app-icon name="shield" />
            <span>{{ 'settings.admin.subscriptions' | translate }}</span>
          </app-button>
          <app-button variant="outlined" routerLink="/admin/regions" data-testid="go-to-admin-regions-button">
            <app-icon name="map" />
            <span>{{ 'settings.admin.regions' | translate }}</span>
          </app-button>
        </div>
      </div>
    </app-card-content>
  </app-card>
</div>
